module.exports = __webpack_public_path__ + "img/capa1.84616cc8.png";